import all from './all';
import latest from './latest';

export default { all, latest };
